module.exports = __webpack_public_path__ + "media/images/favicon6-3f796c5ceb1ef2315b9fe1b1f373a67c.ico";